/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import { initialState } from './defaultState';
import { setValidation } from './actions';

const validationReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setValidation, (state, action) => {
      state[action.payload.validationField] = action.payload.validationContent;
    });
});

export default validationReducer;
